require("pretendard/dist/web/variable/pretendardvariable-dynamic-subset.css")
require("@fontsource/jetbrains-mono/400.css")
require("@fontsource/jetbrains-mono/700.css")
require("katex/dist/katex.min.css")

const { analytics, siteUrl } = require("./blog-config")

const googleMeasurementId = analytics.googleMeasurementId
const productionHostname = new URL(siteUrl).hostname

const isProductionHost = location => {
  return location.hostname === productionHostname
}

exports.onRouteUpdate = () => {
  if (
    !googleMeasurementId ||
    typeof window.gtag !== "function" ||
    !isProductionHost(window.location)
  ) {
    return
  }

  window.setTimeout(() => {
    window.gtag("event", "page_view", {
      page_title: document.title,
      page_location: window.location.href,
    })
  }, 0)
}
